import { render, staticRenderFns } from "./WaterBalanceWizard.vue?vue&type=template&id=708aa7ca&scoped=true&"
import script from "./WaterBalanceWizard.vue?vue&type=script&lang=js&"
export * from "./WaterBalanceWizard.vue?vue&type=script&lang=js&"
import style0 from "./WaterBalanceWizard.vue?vue&type=style&index=0&id=708aa7ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708aa7ca",
  null
  
)

export default component.exports